import { render, staticRenderFns } from "./MallsTab.vue?vue&type=template&id=662e86c5&"
import script from "./MallsTab.vue?vue&type=script&lang=ts&"
export * from "./MallsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports